import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import styles from './AdagioSwiper.module.scss'

const cx = classnames.bind(styles)

export default function SlideCounter({ swiper, total }) {
  const [index, setIndex] = useState(swiper?.activeIndex ?? 0)

  useEffect(() => {
    if (!swiper || swiper.destroyed) {
      return undefined
    }

    const update = () => setIndex(swiper.activeIndex)
    update()
    swiper.on('slideChange', update)

    return () => {
      if (!swiper.destroyed) {
        swiper.off('slideChange', update)
      }
    }
  }, [swiper])

  return (
    <span className={cx('counter')}>
      {index + 1} / {total}
    </span>
  )
}

SlideCounter.propTypes = {
  swiper: PropTypes.object,
  total: PropTypes.number.isRequired,
}
